import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import selArea from '@/pages/selArea'
import loginCourse from '@/pages/Login/LoginCourse'
import email from '@/pages/email'
import asks from '@/pages/asks'
import success from '@/pages/success'
import fail from '@/pages/fail'
import cancel from '@/pages/cancel'


import Login from '@/pages/Login/Login'
Vue.use(Router)

const grouter = new Router({
 /* mode: 'history',
  base: '/#', // newPay1基础路径 */
  routes: [{
    path:'/login',
    name:'Login',
    component: Login
  },
  {
    path: '/index',
    name: 'index',
    component: index
  },
  {
    path: '/selArea',
    name: 'selArea',
    component: selArea
  },
  {
    path: '/loginCourse',
    name: 'loginCourse',
    component: loginCourse
  },
  {
    path: '/success',
    name: 'success',
    component: success
  },
  {
    path: '/fail',
    name: 'fail',
    component: fail
  },
  {
    path: '/cancel',
    name: 'cancel',
    component: cancel
  },
  {
    path: '/asks',
    name: 'asks',
    component: asks
  },
  {
    path: '/email',
    name: 'email',
    component: email
  },
  {
      // 配置404页面,重定向到首页
      path: '/:catchAll(.*)',
      redirect: '/index'
  }
  ]
})


grouter.beforeEach((to, from, next) => {

  // 配置固定链接参数
  const fixedQuery = ['code']
  // 判断from中query有没有code参数，如果有加到to中
  if (from.query && from.query.code) {
    let newQuery  = {
      ...to.query, // 保留目标路由已有的查询参数
    }
    let hasModified = false
    fixedQuery.forEach((item) => {
      // 如果to中没有这个参数，就把from中的加到to中
      if (!newQuery[item] && from.query[item]) {
        newQuery[item] = from.query[item]
        hasModified = true
      }
    })
    // to.query = newQuery
    // 如果查询参数有变化，则重定向到新路由
    if (hasModified) {
      next({
        path: to.path,
        query: newQuery,
      })
      return
    }
  }


  if(from.path === '/login'){
    setTimeout(() => {
      next();
    }, 200)
  }
  else {
    next();
  }
})

export default grouter;



// WEBPACK FOOTER //
// ./src/router/index.js